import common from '../../common';

const _hide = Symbol('_hide');
const _onHidden = Symbol('_onHidden');

export default class ConfirmationPanel extends PIXI.Container {
	constructor() {
		super();
		// Attributes.
		this._bgSprite = null;
		this._messageSprite = null;
		this._messageText = null;
		this._yesBtn = null;
		this._noBtn = null;
		this._selectedBtn = null;

		// Signals.
		this.signals = {};
		this.signals.onYes = new P3.utils.MiniSignal();
		this.signals.onNo = new P3.utils.MiniSignal();

		this._tweens = new P3.utils.TWEEN.Group();
	}

	init() {
		const panelConfig = common.levelConfig.menu_panel;

		// Background sprite.
		this._bgSprite = new PIXI.Sprite(PIXI.Texture.WHITE);
		this._bgSprite.anchor = new PIXI.Point(0.5, 0.5);
		this._bgSprite.tint = 0x000000;
		this._bgSprite.alpha = 0.3;
		this._bgSprite.interactive = true;
		this._bgSprite.width = common.STAGE_WIDTH;
		this._bgSprite.height = common.STAGE_HEIGHT;
		this.addChild(this._bgSprite);

		// Message sprite.
		this._messageSprite = new PIXI.Sprite(P3.assets.texture(panelConfig.bg.texture));
		this._messageSprite.anchor = new PIXI.Point(panelConfig.bg.anchor.x, panelConfig.bg.anchor.y);
		this._messageSprite.position.set(panelConfig.bg.position.x, panelConfig.bg.position.y);
		this._messageSprite.scale.set(panelConfig.bg.scale.x, panelConfig.bg.scale.y);
		this.addChild(this._messageSprite);

		this._messageSprite._topBar = new PIXI.Sprite(P3.assets.texture(panelConfig.top_bar.texture));
		this._messageSprite._topBar.anchor.set(panelConfig.top_bar.anchor.x, panelConfig.top_bar.anchor.y);
		this._messageSprite._topBar.position.set(
			panelConfig.top_bar.position.x,
			(-this._messageSprite.height * 0.5 + this._messageSprite._topBar.height * 0.5 - 25) + panelConfig.top_bar.position.y
		);
		this._messageSprite._topBar.scale.set(panelConfig.top_bar.scale.x, panelConfig.top_bar.scale.y);
		this._messageSprite.addChild(this._messageSprite._topBar);

		// Message text.
		this._messageText = P3.createText('COLOUR_IT', {
			size: '40px',
			fill: 'white',
			stroke: '#2c1812',
			stokeThickness: 5,
			wordWrap: true,
			wordWrapWidth: this._messageSprite.width - 275
		}, 'truetype');

		this._messageText.anchor = new PIXI.Point(0.5, 0);
		this._messageText.y = -115;
		this._messageText.x = -panelConfig.bg.position.x;
		this._messageSprite.addChild(this._messageText);

		// Yes button.
		this._yesBtn = createButton('tick', 'primary_large');
		this._yesBtn.anchor = new PIXI.Point(0.5, 0.5);
		this._yesBtn.position = new PIXI.Point(100 - panelConfig.bg.position.x, this._messageSprite.height * 0.5 - 140);
		this._yesBtn.overSoundName = 'sfx_ui_rollover_00';
		this._yesBtn.downSoundName = 'sfx_ui_click_00';
		this._messageSprite.addChild(this._yesBtn);

		// No button.
		this._noBtn = createButton('cross', 'primary_large');
		this._noBtn.anchor = new PIXI.Point(0.5, 0.5);
		this._noBtn.position = new PIXI.Point(-100 - panelConfig.bg.position.x, this._messageSprite.height * 0.5 - 140);
		this._noBtn.overSoundName = 'sfx_ui_rollover_00';
		this._noBtn.downSoundName = 'sfx_ui_click_00';
		this._messageSprite.addChild(this._noBtn);

		this.visible = false;
	}

	show(message) {
		console.log(message);
		this.visible = true;
		this._messageText.text = message;

		this._messageSprite.alpha = 0;
		this._messageSprite.y = -75;
		new P3.utils.TWEEN.Tween(this._messageSprite, this.tweens)
		    .to({
				y: this._messageSprite.y + 100, alpha: 1
		    }, 250)
		    .easing(P3.utils.TWEEN.Easing.Quadratic.Out)
		    .start();

		this._bgSprite.alpha = 0;
		new P3.utils.TWEEN.Tween(this._bgSprite, this.tweens)
			.to({
				alpha: 0.3
			}, 250)
			.easing(P3.utils.TWEEN.Easing.Quadratic.Out)
			.start();

		this._noBtn.alpha = 0;
		this._noBtn.scale = new PIXI.Point();
		this._yesBtn.alpha = 0;
		this._yesBtn.scale = new PIXI.Point();

		new P3.utils.TWEEN.Tween(this._noBtn.scale, this.tweens)
		    .to({
		        x: 1, y: 1
		    }, 340)
			.delay(150)
		    .easing(P3.utils.Easing.Back2.Out)
		    .onUpdate(()=> {
				this._yesBtn.alpha = this._noBtn.alpha = this._noBtn.scale.x;
		        this._yesBtn.scale = this._noBtn.scale;
		    })
		    .start();

		// Signals.
		this._yesBtn.signals.click.once(()=> {
			this._selectedBtn = this._yesBtn;
			this[_hide]();
		}, this);
		this._noBtn.signals.click.once(()=> {
			this._selectedBtn = this._noBtn;
			this[_hide]();
		}, this);
	}

	destroy(options) {
		this._tweens.removeAll();
		super.destroy();
	}

	update() {
		this._tweens.update();
	}

	[_hide]() {
		new P3.utils.TWEEN.Tween(this._messageSprite, this.tweens)
		    .to({
		        y: this._messageSprite.y + 100, alpha: 0
		    }, 250)
		    .easing(P3.utils.TWEEN.Easing.Quadratic.In)
		    .start();

		new P3.utils.TWEEN.Tween(this._bgSprite, this.tweens)
		    .to({
		        alpha: 0
		    }, 250)
		    .easing(P3.utils.TWEEN.Easing.Quadratic.In)
		    .onComplete(()=> {
		        this[_onHidden]();
		    })
		    .start();

		// Signals.
		this._yesBtn.signals.click.detachAll();
		this._noBtn.signals.click.detachAll();
	}

	[_onHidden]() {
		if (this._selectedBtn === this._yesBtn)
			this.signals.onYes.dispatch();
		else if (this._selectedBtn === this._noBtn)
			this.signals.onNo.dispatch();

		this._selectedBtn = null;

		this.visible = false;

		// Signals.
		this.signals.onYes.detachAll();
		this.signals.onNo.detachAll();
	}

	get tweens() {
		return this._tweens;
	}
}
